import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Button, IconHeartOn16, IconHeartOff16 } from '@cian/ui-kit';
import { debounce } from 'throttle-debounce';

import { TThunkDispatch } from '../../types/redux/thunk';
import { addFavorite, deleteFavorite } from '../../actions/favorite';
import { FAVORITE_DEBOUNCE_DELAY } from '../../constants/delays';
import { useOfferContext } from '../../utils/offerContext';

export const FavoriteContainer: React.VFC = () => {
  const {
    id,
    isFavorite,
    analytics: { gaLabel },
  } = useOfferContext();
  const dispatch = useDispatch<TThunkDispatch>();

  const handleClick = React.useCallback(
    debounce(FAVORITE_DEBOUNCE_DELAY, () => {
      if (isFavorite) {
        dispatch(deleteFavorite({ offerId: id, label: gaLabel }));
      } else {
        dispatch(addFavorite({ offerId: id, label: gaLabel }));
      }
    }),
    [dispatch, id, isFavorite, gaLabel],
  );

  if (isFavorite == null) {
    return null;
  }

  return (
    <Button
      onClick={handleClick}
      theme="fill_secondary"
      size="XS"
      beforeIcon={isFavorite ? <IconHeartOn16 color="error_100" /> : <IconHeartOff16 color="error_100" />}
    >
      {isFavorite ? 'В избранном' : 'В избранное'}
    </Button>
  );
};
